import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'prizm-roadmap',
  templateUrl: './roadmap.component.html',
  styleUrls: ['./roadmap.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RoadmapComponent {}
